import SideBar from '../../components/SideBar/SideBar';
import TopNav from '../../components/TopNav/TopNav';
import './AdManagement.scss';

import upload from '../../assets/images/icons/upload.svg';

function AdManagement() {
    return (
        <main>
            <TopNav />
            <div className='main-container'>
                <SideBar />
                <article style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                    <section className='ad-management'>
                        <div className='ad-management__top'>
                            <h1 className='ad-management__top-heading'>
                                Ad Management
                            </h1>
                            <button className='ad-management__top-clear'>
                                <p className='ad-management__top-clear-text'>
                                    Export data
                                </p>
                                <img className='ad-management__top-clear-icon' src={upload} alt='upload icon'></img>
                            </button>
                        </div>

                        <section className='no-data'>
                            <div className='no-data__container'>
                                <p className='no-data__container-text'>
                                    There is no ad management data at this time
                                </p>

                            </div>
                        </section>
                    </section>
                </article>
            </div>
        </main>
    )
}

export default AdManagement
